import {
  AccessibilityNew,
  AppSettingsAlt,
  AttachEmail,
  // AttachMoney,
  AutoDelete,
  CalendarMonth,
  CloudDownload,
  DashboardCustomize,
  EditNotifications,
  Email,
  FlagCircleOutlined,
  Groups,
  Handshake,
  // Insights,
  Loyalty,
  ManageAccounts,
  PermDataSetting,
  RestorePage,
  // RssFeed,
  SatelliteAlt,
  Sms,
} from '@mui/icons-material';
import AirlineSeatReclineExtraOutlinedIcon from '@mui/icons-material/AirlineSeatReclineExtraOutlined';
import BuildIcon from '@mui/icons-material/Build';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import ContactsIcon from '@mui/icons-material/Contacts';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import EmailIcon from '@mui/icons-material/Email';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PaymentIcon from '@mui/icons-material/Payment';
import PercentIcon from '@mui/icons-material/Percent';
import PolicyIcon from '@mui/icons-material/Policy';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { BiUpload } from 'react-icons/bi';
import { CgPlayListRemove, CgExtensionAdd } from 'react-icons/cg';
// import { DiJqueryUiLogo } from 'react-icons/di';
import { FaRegShareSquare } from 'react-icons/fa';
// import { FiUserPlus } from 'react-icons/fi';
// import { HiTemplate } from 'react-icons/hi';
import { IoIosAnalytics } from 'react-icons/io';
// import { IoPrismSharp } from 'react-icons/io5';
import {
  MdOutlineManageAccounts,
  MdOutlineAddReaction,
  // MdOutlineManageSearch,
  // MdConnectWithoutContact,
  MdOutlineScreenSearchDesktop,
  MdOutlineSettingsBrightness,
  MdOutlineHelpOutline,
} from 'react-icons/md';
import { RiFileSettingsLine } from 'react-icons/ri';
import { SiTorbrowser, SiGithubactions } from 'react-icons/si';
import { VscCompassActive, VscSettings } from 'react-icons/vsc';
import { WsRevenueCalculator } from 'wisestep-base';

export const teamsAndUsersOptions = [
  {
    label: 'Manage Teams',
    url: '/teams',
    icon: <Groups />,
    SKU: '',
  },
  { label: 'Manage Users', url: '/users', icon: <ManageAccounts />, SKU: '' },
  { label: 'Business Units', url: '/business_unit', icon: <BusinessRoundedIcon />, SKU: '' },
  {
    label: 'Organizational Units',
    url: '/organizational_unit',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  { label: 'Data Sharing', url: '/data-sharing', icon: <FaRegShareSquare />, SKU: '' },
  { label: 'Data Download', url: '/data-download/jobs', icon: <CloudDownload />, SKU: '' },
];

export const teamsAndOptions = [
  {
    label: 'Manage Teams',
    url: '/teams',
    icon: <Groups />,
    SKU: '',
  },
  { label: 'Data Sharing', url: '/data-sharing', icon: <FaRegShareSquare />, SKU: '' },
  { label: 'Data Download', url: '/data-download/jobs', icon: <CloudDownload />, SKU: '' },
];

export const jobsOptionsFields = {
  label: 'Customise Job Fields',
  url: '/job-fields-settings',
  icon: <DashboardCustomize />,
  SKU: 'JS_CUSTOM_JOB_ATTRIBUTES',
};

export const jobsDataDownload = {
  label: 'Data Download Settings',
  url: '/jobs-download-settings',
  icon: <DownloadForOfflineIcon />,
  SKU: '',
};

export const jobsAttributeVisibility = {
  label: 'Job Attribute Visibility Settings',
  url: '/job-attribute-visibility-setting',
  icon: <MdOutlineSettingsBrightness />,
  SKU: '',
};

export const defineJobClosing = {
  label: 'Define Reasons for Closing a Job',
  url: '/close-job-reason',
  icon: <CgPlayListRemove />,
  SKU: '',
};

export const configureJobPosting = {
  label: 'Configure Job Posting Settings',
  url: '/job-posting-settings',
  icon: <VscSettings />,
  SKU: '',
};

export const jobsOptions = [
  {
    label: 'Customise Job Fields',
    url: '/job-fields-settings',
    icon: <DashboardCustomize />,
    SKU: 'JS_CUSTOM_JOB_ATTRIBUTES',
  },
  {
    label: 'Data Download Settings',
    url: '/jobs-download-settings',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  // {
  //   label: 'Add Brand Logo (Coming Soon)',
  //   url: './',
  //   icon: <DiJqueryUiLogo />,
  //   SKU: '',
  // // },
  // { label: 'RSS Feed (Coming Soon)', url: './', icon: <RssFeed />, SKU: '' },
  // {
  //   label: 'Auto closure of Jobs (Coming Soon)',
  //   url: './',
  //   icon: <BiWindowClose />,
  //   SKU: '',
  // },
  {
    label: 'Define Reasons for Closing a Job',
    url: '/close-job-reason',
    icon: <CgPlayListRemove />,
    SKU: '',
  },
  {
    label: 'Configure Job Posting Settings',
    url: '/job-posting-settings',
    icon: <VscSettings />,
    SKU: '',
  },
  {
    label: 'Job Attribute Visibility Settings',
    url: '/job-attribute-visibility-setting',
    icon: <MdOutlineSettingsBrightness />,
    SKU: '',
  },
];
export const analyticsOptions = [
  {
    label: 'Active Pipeline Default View',
    url: './',
    icon: <VscCompassActive />,
    SKU: '',
  },
  {
    label: 'Mapping Analytics Default View',
    url: './',
    icon: <IoIosAnalytics />,
    SKU: '',
  },
  {
    label: 'Analytics Settings',
    url: '/analytics-settings',
    icon: <PermDataSetting />,
    SKU: '',
  },
];

export const crmCustomizeMappingForm = {
  label: 'Customise Mapping form',
  url: '/crm-settings/configure-mapping-form',
  icon: <BuildIcon />,
  SKU: '',
};

export const crmCustomizeSubmissionFlow = {
  label: 'Customise Submission Flow',
  url: '/crm-settings/configure-submission-flow',
  icon: <BuildIcon />,
  SKU: '',
};

export const crmManageRecruiterActions = {
  label: 'Manage Recruiter Actions',
  url: '/candidate-interaction-messaging/',
  icon: <MdOutlineAddReaction />,
  SKU: 'CS_MANAGE_RECRUITER_ACTIONS',
};

export const crmManageCandidateResponse = {
  label: 'Manage Candidate Response',
  url: '/candidate-interaction-result-pipeline',
  icon: <SiGithubactions />,
  SKU: '',
};

export const crmCandidateDownload = {
  label: 'Data Download Settings',
  url: '/download-settings/data-download',
  icon: <DownloadForOfflineIcon />,
  SKU: '',
};

export const crmPaginationSettings = {
  label: 'Pagination Settings',
  url: '/pagination-settings',
  icon: <RestorePage />,
  SKU: '',
};

export const crmStageStatus = {
  label: 'Manage Stage Status',
  url: '/candidate-stage-status-pipeline-settings',
  icon: <MdOutlineManageAccounts />,
  SKU: 'CS_MANAGE_STAGE_STATUS',
};

export const prismSettings = {
  label: 'Prism Settings',
  url: '/prism-extension-settings/',
  icon: <AppSettingsAlt />,
  SKU: '',
};

export const crmOptions = [
  {
    label: 'Customise Submission Flow',
    url: '/crm-settings/configure-submission-flow',
    icon: <BuildIcon />,
    SKU: '',
  },
  {
    label: 'Customise Mapping form',
    url: '/crm-settings/configure-mapping-form',
    icon: <BuildIcon />,
    SKU: '',
  },
  {
    label: 'Manage Stage Status',
    url: '/candidate-stage-status-pipeline-settings',
    icon: <MdOutlineManageAccounts />,
    SKU: 'CS_MANAGE_STAGE_STATUS',
  },
  {
    label: 'Manage Recruiter Actions',
    url: '/candidate-interaction-messaging/',
    icon: <MdOutlineAddReaction />,
    SKU: 'CS_MANAGE_RECRUITER_ACTIONS',
  },
  {
    label: 'Manage Candidate Response',
    url: '/candidate-interaction-result-pipeline',
    icon: <SiGithubactions />,
    SKU: '',
  },
  // {
  //   label: 'Manage Mapping Fields (Coming Soon)',
  //   url: './',
  //   icon: <MdOutlineManageSearch />,
  //   SKU: '',
  // },
  // {
  //   label: 'Manage Candidate Submission Fields (Coming Soon)',
  //   url: './',
  //   icon: <RiPlayListAddLine />,
  //   SKU: '',
  // },
  {
    label: 'Data Download Settings',
    url: '/download-settings/data-download',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'Pagination Settings',
    url: '/pagination-settings',
    icon: <RestorePage />,
    SKU: '',
  },
  {
    label: 'Organization Logo',
    url: '/workspace-settings/organization-logo',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Evaluation Template',
    url: '/evaluation-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Information Categories',
    url: '/information-categories',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'RTR Template',
    url: '/rtr-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Automated Email Campaign',
    url: '/automated-email-campaign-settings/',
    icon: <EmailIcon />,
  },
  {
    label: 'Contract Revenue Calculator',
    url: '/contract_revenue_calculator',
    icon: <WsRevenueCalculator />,
    SKU: '',
  },
  {
    label: 'CRM Job Settings',
    url: '/crm-job-settings',
    icon: <BuildIcon />,
    SKU: '',
  },
];
export const crusibleCrmOptions = [
  {
    label: 'Customise submission form',
    url: '/crm-settings/configure-submission-form',
    icon: <BuildIcon />,
    SKU: '',
  },
  {
    label: 'Manage Stage Status',
    url: '/candidate-stage-status-pipeline-settings',
    icon: <MdOutlineManageAccounts />,
    SKU: 'CS_MANAGE_STAGE_STATUS',
  },
  {
    label: 'Customise Mapping Form',
    url: '/candidate-interaction-messaging/',
    icon: <MdOutlineAddReaction />,
    SKU: 'CS_MANAGE_RECRUITER_ACTIONS',
  },
  // {
  //   label: 'Manage Candidate Response',
  //   url: '/candidate-interaction-result-pipeline',
  //   icon: <SiGithubactions />,
  //   SKU: '',
  // },
  // {
  //   label: 'Manage Mapping Fields (Coming Soon)',
  //   url: './',
  //   icon: <MdOutlineManageSearch />,
  //   SKU: '',
  // },
  // {
  //   label: 'Manage Candidate Submission Fields (Coming Soon)',
  //   url: './',
  //   icon: <RiPlayListAddLine />,
  //   SKU: '',
  // },
  {
    label: 'Data Download Settings',
    url: '/download-settings/data-download',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'Pagination Settings',
    url: '/pagination-settings',
    icon: <RestorePage />,
    SKU: '',
  },
  {
    label: 'Currencies',
    url: '/currencies',
    icon: <PaymentIcon />,
    SKU: '',
  },
  {
    label: 'File Categories',
    url: '/app-settings/file_categories',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  {
    label: 'Business Units',
    url: '/business_unit',
    icon: <BusinessCenterIcon />,
    SKU: '',
  },
  {
    label: 'Organization Logo',
    url: '/workspace-settings/organization-logo',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Evaluation Template',
    url: '/evaluation-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Information Categories',
    url: '/information-categories',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'RTR Template',
    url: '/rtr-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Contract Revenue Calculator',
    url: '/contract_revenue_calculator',
    icon: <WsRevenueCalculator />,
    SKU: '',
  },
  {
    label: 'CRM Job Settings',
    url: '/crm-job-settings',
    icon: <BuildIcon />,
    SKU: '',
  },
];
export const crmOptionsWithEvaluation = [
  {
    label: 'Customise Mapping form',
    url: '/crm-settings/configure-mapping-form',
    icon: <BuildIcon />,
    SKU: '',
  },
  {
    label: 'Customise Submission Flow',
    url: '/crm-settings/configure-submission-flow',
    icon: <BuildIcon />,
    SKU: '',
  },
  {
    label: 'Manage Stage Status',
    url: '/candidate-stage-status-pipeline-settings',
    icon: <MdOutlineManageAccounts />,
    SKU: 'CS_MANAGE_STAGE_STATUS',
  },
  {
    label: 'Manage Recruiter Actions',
    url: '/candidate-interaction-messaging/',
    icon: <MdOutlineAddReaction />,
    SKU: 'CS_MANAGE_RECRUITER_ACTIONS',
  },
  {
    label: 'Manage Candidate Response',
    url: '/candidate-interaction-result-pipeline',
    icon: <SiGithubactions />,
    SKU: '',
  },
  // {
  //   label: 'Manage Mapping Fields (Coming Soon)',
  //   url: './',
  //   icon: <MdOutlineManageSearch />,
  //   SKU: '',
  // },
  // {
  //   label: 'Manage Candidate Submission Fields (Coming Soon)',
  //   url: './',
  //   icon: <RiPlayListAddLine />,
  //   SKU: '',
  // },
  {
    label: 'Data Download Settings',
    url: '/download-settings/data-download',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'Pagination Settings',
    url: '/pagination-settings',
    icon: <RestorePage />,
    SKU: '',
  },
  {
    label: 'Organization Logo',
    url: '/workspace-settings/organization-logo',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Evaluation Template',
    url: '/evaluation-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Information Categories',
    url: '/information-categories',
    icon: <DownloadForOfflineIcon />,
    SKU: '',
  },
  {
    label: 'RTR Template',
    url: '/rtr-template',
    icon: <BusinessRoundedIcon />,
    SKU: '',
  },
  {
    label: 'Contract Revenue Calculator',
    url: '/contract_revenue_calculator',
    icon: <WsRevenueCalculator />,
    SKU: '',
  },
  {
    label: 'CRM Job Settings',
    url: '/crm-job-settings',
    icon: <BuildIcon />,
    SKU: '',
  },
];

export const accountOptions = [
  // {
  //   label: 'Account information (Coming Soon)',
  //   url: './',
  //   icon: <ManageAccounts />,
  //   SKU: '',
  // },
  // {
  //   label: 'Plans and Billing (Coming Soon)',
  //   url: './',
  //   icon: <AttachMoney />,
  //   SKU: '',
  // },
  // { label: 'Career Pages (Coming Soon)', url: './', icon: <RiPagesLine />, SKU: '' },
  // { label: 'Invite Vendors (Coming Soon)', url: './', icon: <FiUserPlus />, SKU: '' },
  // {
  //   label: 'Communication Settings (Coming Soon)',
  //   url: './',
  //   icon: <MdConnectWithoutContact />,
  //   SKU: '',
  // },
  { label: 'Subscription', url: './', icon: <Loyalty />, SKU: '' },
  {
    label: 'Notification Settings',
    url: '/notification-settings',
    icon: <EditNotifications />,
    SKU: '',
  },
  { label: 'Access Control', url: '/access-control', icon: <AccessibilityNew />, SKU: '' },
  {
    label: 'MFA Authenticator',
    icon: <GppGoodOutlinedIcon sx={{ fontSize: 29, paddingLeft: 0, marginLeft: -0.2 }} />,
    url: '/recruiter/mfa-authenticator',
  },
];
export const dataPrivacyOptions = [
  {
    label: 'Data Subject Access Request Setup',
    url: '/setup',
    icon: <AccessibilityNew />,
    SKU: '',
  },
  { label: 'Delete Requests', url: '/delete-requests/', icon: <AutoDelete />, SKU: '' },
  { label: 'Contact Info Access Setup', url: './', icon: <ContactsIcon />, SKU: '' },
];
export const appsAndIntegrationsOptions = [
  { label: 'External Job Posting', url: '/job-boards', icon: <CgExtensionAdd />, SKU: '' },
  {
    label: 'Native Search',
    url: '/native-search-settings/',
    icon: <MdOutlineScreenSearchDesktop />,
    SKU: '',
  },
  {
    label: 'Communication Accounts',
    url: '/sms-configuration',
    icon: <SatelliteAlt />,
    SKU: '',
  },
  { label: 'Email Settings', url: '/email-settings/', icon: <Email />, SKU: '' },
  {
    label: 'Templates',
    url: '/template-settings/email-template-settings',
    icon: <Email />,
    SKU: '',
  },
  { label: 'SMS Settings', url: './', icon: <Sms />, SKU: '' },
  {
    label: 'Mass Mailing Credits',
    url: '/vendors/mailing-credits',
    icon: <AttachEmail />,
    SKU: '',
  },
  // {
  //   label: 'Prism Extension',
  //   url: '/prism-download',
  //   icon: <IoPrismSharp />,
  //   SKU: '',
  // },
  {
    label: 'CV Uploader App',
    url: '/bulk-importer',
    icon: <BiUpload />,
    SKU: '',
  },
  {
    label: 'Outlook Extension',
    url: 'https://appsource.microsoft.com/en-us/product/office/WA200002649?tab=Overview',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  {
    label: 'Vendor Management System',
    url: '/vms',
    icon: <Handshake />,
    SKU: '',
  },
  {
    label: 'Browser Extension',
    url: 'https://chrome.google.com/webstore/detail/recruitment-automation-by/dhbkmcoahmolllnkkpgniamjkldaemgm',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  // {
  //   label: 'Private Extension',
  //   url: '/private-extension/',
  //   icon: <SiTorbrowser />,
  //   SKU: '',
  // },
  {
    label: 'Resume Parsing by Email ',
    url: '/resume-parsing-by-email/',
    icon: <Email />,
    SKU: '',
  },
  {
    label: 'Create Leads via Email ',
    url: '/leads-email',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  {
    label: 'Create Notes via Email ',
    url: '/notes-email',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  { label: 'Calendar', url: '/calender-settings', icon: <CalendarMonth />, SKU: '' },
];
export const careerPagesOptions = [
  {
    label: 'Career Page Settings',
    url: '/app-settings/career-page/general',
    icon: <RiFileSettingsLine />,
    SKU: 'CP_CAREER_PAGES',
  },
  {
    label: 'Talent Magnet Settings',
    url: '/app-settings/cv-upload-settings/appearance',
    icon: <RiFileSettingsLine />,
    SKU: '',
  },
];
export const invoiceModuleOptions = [
  {
    label: 'Payment Type',
    url: '/invoice/settings/payment_type',
    icon: <PaymentIcon />,
    SKU: '',
  },
  {
    label: 'Tax Type',
    url: '/invoice/settings/tax_type',
    icon: <PercentIcon />,
    SKU: '',
  },
  {
    label: 'Invoice Type',
    url: '/invoice/settings/invoice_type',
    icon: <ReceiptIcon />,
    SKU: '',
  },
  {
    label: 'Invoice Extras',
    url: '/invoice/settings/invoice_extra',
    icon: <ReceiptIcon />,
    SKU: '',
  },
  {
    label: 'Customize Invoice Fields',
    url: '/invoice/settings/customize-invoice-fields',
    icon: <ReceiptIcon />,
    SKU: '',
  },
  {
    label: 'Create Invoice Template',
    url: '/invoice/template',
    icon: <ReceiptIcon />,
    SKU: '',
  },
  {
    label: 'Terms and Conditions',
    url: '/invoice/settings/terms-and-conditions',
    icon: <ReceiptIcon />,
    SKU: '',
  },
];
export const clientModuleOptions = [
  {
    label: 'Client Status',
    url: '/clients/client-status',
    icon: <MdOutlineManageAccounts />,
    SKU: '',
  },
  {
    label: 'Currencies',
    url: '/currencies',
    icon: <PaymentIcon />,
    SKU: '',
  },
  {
    label: 'File Categories',
    url: '/app-settings/file_categories',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  {
    label: 'Legal Identifiers',
    url: '/legal_identifiers',
    icon: <PolicyIcon />,
    SKU: '',
  },
  {
    label: 'Fee Arrangements',
    url: '/position_levels',
    icon: <ReceiptIcon />,
    SKU: '',
  },
  {
    label: 'Customize Client Fields',
    url: '/app-settings/customize-client-fields',
    icon: <ManageAccountsIcon />,
    SKU: '',
  },
  {
    label: 'Lead Status',
    url: '/leads/lead-status',
    icon: <MdOutlineManageAccounts />,
    SKU: '',
  },
];

export const placementModuleOptions = [
  {
    label: 'Placement Status',
    url: '/placements/settings/placement_status',
    icon: <AirlineSeatReclineExtraOutlinedIcon />,
    SKU: '',
  },
  {
    label: 'Placement Origin',
    url: '/placements/settings/placement_origin',
    icon: <FlagCircleOutlined />,
    SKU: '',
  },
  {
    label: 'Placement Stage',
    url: '/placements/settings/placement_stage',
    icon: <FlagCircleOutlined />,
    SKU: '',
  },
  {
    label: 'Customize Placement Fields',
    url: '/app-settings/customize-placement-fields',
    icon: <ManageAccountsIcon />,
    SKU: '',
  },
];

export const helpAndKnowledgeOptions = [
  // { label: 'Email Templates (Coming Soon)', url: './', icon: <HiTemplate />, SKU: '' },
  // {
  //   label: 'Company Insights + News (Coming Soon)',
  //   url: './',
  //   icon: <Insights />,
  //   SKU: '',
  // },
  // { label: 'Scripts (Coming Soon)', url: './', icon: <CgTranscript />, SKU: '' },
  {
    label: 'FAQs',
    url: '/help-and-knowledge/faq',
    icon: <MdOutlineHelpOutline size={25} />,
    SKU: '',
  },
];

export const workspaceSettingOptions = [];
